import { useEffect, useState } from "react";
import { createGlobalStore } from "hox";
import CONST from "@/config/const.js";
import { useSize, useDebounce, useRequest } from "ahooks";
import cookie from "@/utils/cookie";
import service from "@/services/pagemode";
import QRCode from "qrcode";
import {
  DEFAULT_LANG,
  getLangFromPath,
  switchLangPath,
} from "@/utils/langPath";

const getLan = () => {
  return cookie.read("lan") || getLangFromPath() || DEFAULT_LANG;
};
export const [usePageMode, getPageMode] = createGlobalStore(() => {
  const [mode, setMode] = useState(
    cookie.read("cusSkin") == 1 || !cookie.read("cusSkin") ? "dark" : "light"
  ); // 1 dark， 2 light
  const [lang, setLang] = useState(getLangFromPath());
  const [curr_rate, setCurrRate] = useState(cookie.read("curr_rate") || "USD");
  const [appdownload, setDownloadInfo] = useState({});

  const size = useSize(window.document.documentElement);
  const sizeDebounce = useDebounce(size, { wait: 20 });

  function changePageMode(task) {
    cookie.write("cusSkin", task == "light" ? 2 : 1);
    setMode(task);
  }
  function changeLang(task) {
    let item = CONST.langList.find((item) => item.id == task);
    if (item) {
      cookie.write("lan", task);
      localStorage.lang = task;
      setLang(task);
      const nextPath = switchLangPath(window.location.pathname, task);
      window.location.href = nextPath + window.location.search;
    }
  }
  function changeRate(longKey) {
    cookie.write("curr_rate", longKey);
    setCurrRate(longKey);
  }

  const { loading, runAsync } = useRequest(service.appdownload, {
    manual: true,
  });
  const getDownload = async () => {
    try {
      const res = await runAsync({
        payload: {},
      });

      if (res.code == 0) {
        let obj = res.data;
        obj.app_page_url = await QRCode.toDataURL(obj.download_serve_url);
        setDownloadInfo(obj);
      }
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    getDownload();
    if (!cookie.read("cusSkin")) {
      cookie.write("cusSkin", 1);
    }
    const pathLang = getLangFromPath();
    cookie.write("lan", pathLang);
    localStorage.lang = pathLang;
    setLang(pathLang);
  }, []);
  return {
    mode,
    lang,
    curr_rate,
    changePageMode,
    changeLang,
    changeRate,
    bodySize: sizeDebounce,
    appdownload,
  };
});
